import Card from "features/shared/components/card/Card";
import Icon from "features/shared/components/icons/Icon";
import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";
import RadioBoxBoolSubForm from "features/shared/forms/components/radioBox/RadioBoxBoolSubForm";
import { UseFormHookResult } from "features/shared/forms/hooks/useForm";
import React, { useEffect } from "react";
import styles from "./consentsSubForm.module.scss";
import { setConsentsValidations } from "features/contracting/sections/contractingForms/overviewForm/overviewFormValidation";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";

type Props = {
  consents: UserEnumDTO[];
  formHandler: UseFormHookResult;
};

const ConsentsSubForm = ({ consents, formHandler }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "consentsSubForm");

  // form hook props
  const {
    setValidationRule,
  } = { ...formHandler };

  // side-effects
  useEffect(() => {
    // set default validations
    setConsentsValidations(consents, setValidationRule);
  }, []);

  // sub-renders
  const renderConsensts = () => {
    return consents.map((consent) => (
      <Card key={consent.code} className="p-3">
        <div className="row no-gutters align-items-center">
          <div className="col-sm">
            <div className="d-flex align-items-center">
              <span className={styles.consentIcon}>
                <Icon icon="check" size="lg" />
              </span>
              <span>{consent.name}</span>
            </div>
          </div>
          <div className="col-sm-auto pl-sm-3 mt-3 mt-sm-0">
            <RadioBoxBoolSubForm
              formHandler={formHandler}
              name={`consents.${consent.code}`}
              classNameFormGroup="mb-0"
            />
          </div>
        </div>
      </Card>
    ));
  };

  // render
  return (
    <>
      <h4 className="text-muted mb-3">{tLabels("title")}</h4>
      {renderConsensts()}
    </>
  );
};

export default ConsentsSubForm;
